module.exports = __webpack_public_path__ + "img/home-part-01.0e0ad29c.png";